import { render, staticRenderFns } from "./BookingBoardCard.vue?vue&type=template&id=3861da1c&scoped=true"
import script from "./BookingBoardCard.vue?vue&type=script&lang=js"
export * from "./BookingBoardCard.vue?vue&type=script&lang=js"
import style0 from "./BookingBoardCard.vue?vue&type=style&index=0&id=3861da1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3861da1c",
  null
  
)

export default component.exports